import React, { FC, useMemo } from "react";
import { WorkOrderStatus } from "@myapp/contract";
import Select from "../../../shared/ui/controls/Select/Select";
import { workOrderStatusOptions } from "../model/workOrderStatus";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const ALL_OPTION: ISelectOption = { value: null, label: "Alle Status" };

interface WorkOrderStatusSelectProps {
  value?: WorkOrderStatus | null;
  onChange?: (value: WorkOrderStatus | null) => void;
  withAllOption?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: string | null;
  size?: "md" | "sm";
}

const WorkOrderStatusSelect: FC<WorkOrderStatusSelectProps> = ({
  value,
  onChange,
  withAllOption = false,
  placeholder = "Status wählen",
  className,
  disabled,
  error,
  size,
}) => {
  const options = useMemo(
    () => (withAllOption ? [ALL_OPTION, ...workOrderStatusOptions] : workOrderStatusOptions),
    [withAllOption],
  );

  return (
    <Select
      options={options}
      value={value ?? null}
      onChange={(v) => onChange?.(v as WorkOrderStatus | null)}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      error={error}
      size={size}
    />
  );
};

export default WorkOrderStatusSelect;
